import {RcfaUserInfo} from '@domain/rcfa'
import {RoleType, ApiClient} from '@hconnect/apiclient'
import {useUserContext} from '@hconnect/login'
import {useMutation} from '@tanstack/react-query'

export type ResponseType = Array<RcfaUserInfo>

export const QueryKey = 'graph-data'

type SearchUserData = {
  emailIdOrPhone?: string
  excludeAnalysisId?: number
}

export const useSearchContributors = () => {
  const {loggedUser} = useUserContext()
  const canAddContributorRole: RoleType[] = [
    'RELIABILITY_ADMIN',
    'GLOBAL_ADMIN',
    'MAINTENANCE_MANAGER',
    'MANAGING_DIRECTOR',
    'PLANT_DIRECTOR',
    'RELIABILITY_ENGINEER'
  ]

  return useMutation({
    mutationFn: async (searchParams: SearchUserData) => {
      const hasRoles = canAddContributorRole.map((r) => loggedUser?.hasRoles?.includes(r))
      const hasRole = hasRoles.reduce((res, cur) => res || cur, false)
      const rcfaUserPath = 'users/reliabilityContributors/' + searchParams.emailIdOrPhone
      const userPath = `users?rowsPerPage=10&page=1&sortColumn=createdOn&sortDirection=desc&eMail=${searchParams.emailIdOrPhone}&skip=0&limit=10`

      if (hasRole) {
        const res = await ApiClient.axiosInstance.get<ResponseType>(userPath, {})
        if (!res.data || res.data.length === 0) {
          return (await ApiClient.axiosInstance.get<ResponseType>(rcfaUserPath, {})).data
        }
        return res.data
      } else {
        return (await ApiClient.axiosInstance.get<ResponseType>(rcfaUserPath, {})).data
      }
    }
  })
}
